var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    popover-menu-container\n    bg-white\n    text-[14px]\n    rounded-[8px]\n    overflow-hidden\n    font-sans\n    py-1\n    px-[2px]\n  "},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }